import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ADMIN, CORPORATE_ADMIN, HOST_AGENT, SUPER_ADMIN } from '@app/shared/constants';
import { RoleGuard } from '@app/shared/guards/role.guard';

const routes: Routes = [
  {
    path: 'deliver',
    canActivate: [RoleGuard],
    data: { roles: [SUPER_ADMIN, ADMIN, HOST_AGENT] },
    loadChildren: () => import('./pages/deliver-customer/deliver-customer.module').then((m) => m.DeliverCustomerModule),
  },
  {
    path: 'dropoff',
    canActivate: [RoleGuard],
    data: { roles: [SUPER_ADMIN, ADMIN, HOST_AGENT] },
    loadChildren: () => import('./pages/customer-dropoff/customer-dropoff.module').then((m) => m.CustomerDropOffModule),
  },
  {
    path: 'receive',
    canActivate: [RoleGuard],
    data: { roles: [SUPER_ADMIN, ADMIN, HOST_AGENT] },
    loadChildren: () => import('./pages/receive-package/receive-package.module').then((m) => m.ReceivePackageModule),
  },
  {
    path: 'returncourier',
    canActivate: [RoleGuard],
    data: { roles: [SUPER_ADMIN, ADMIN, HOST_AGENT] },
    loadChildren: () => import('./pages/return-courier/return-courier.module').then((m) => m.ReturnCourierModule),
  },
  {
    path: 'shippingtool',
    canActivate: [RoleGuard],
    data: { roles: [SUPER_ADMIN, ADMIN, HOST_AGENT] },
    loadChildren: () => import('./pages/shipping-tool/shipping-tool.module').then(m => m.ShippingToolModule)
  },
  {
    path: 'reporting',
    loadChildren: () => import('./pages/reporting/reporting.module').then(m => m.ReportingModule)
  },
  {
    path: 'admintool',
    canActivate: [RoleGuard],
    data: { roles: [SUPER_ADMIN, ADMIN, CORPORATE_ADMIN] },
    loadChildren: () => import('./pages/admin-tool/admin-tool.module').then(m => m.AdminToolModule)
  },
  { path: '**', redirectTo: 'dropoff' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticatedRoutingModule {}
